/** @format */

import { FaqData, CategoryData } from "../types";

const categoryData: Record<number, CategoryData> = {
   0: {
      id: 0,
      order: 0,
      label: "자주묻는질문",
   },
   1: {
      id: 1,
      order: 1,
      label: "휴대폰 인증",
   },
   2: {
      id: 2,
      order: 2,
      label: "MyID",
   },
   3: {
      id: 3,
      order: 3,
      label: "NFT",
   },
   4: {
      id: 4,
      order: 4,
      label: "보안",
   },
   // 5: {
   //    id: 5,
   //    order: 5,
   //    label: "기타",
   // },
};

const faqData: FaqData[] = [
   {
      title: "휴대폰을 분실해 새로운 기기로 변경했어요.",
      desc: `
      <p>휴대폰을 분실해도 비밀번호 또는 생체 정보가 노출되지 않는 한 개인정보 유출의 위험은 없습니다. 앱을 재설치해 기존에 소셜 로그인한 계정으로 로그인하면 이전 계정 그대로 사용할 수 있습니다.</p>
    `,
      category: 1,
      order: 1,
      isFrequent: true,
   },
   {
      title: "휴대폰 번호가 바뀌었어요. 기존에 발급받은 MyID와 NFT는 어떻게 되나요?",
      desc: `
    <p>쯩 for 공공기관은 소셜 로그인 기반의 서비스로, 휴대폰 번호가 바뀌어도 소셜 로그인 후 휴대폰 인증을 통해 이전에 발급받은 MyID와 NFT를 바로 불러올 수 있습니다.</p>
    `,
      category: 1,
   },
   {
      title: "휴대폰 유심을 바꾸거나 명의를 변경하면 어떻게 해야 하나요?",
      desc: `
      <p>휴대폰 유심을 바꾸거나 명의가 변경된 경우에도 기존 앱과 발급받은 MyID와 NFT는 사용할 수 있습니다. 하지만 휴대폰 본인 인증 사용을 위해서는 휴대폰 인증 재발급이 필요하니, 휴대폰 인증 상세 화면에서 재발급을 받아주세요.</p>
    `,
      category: 1,
   },
   {
      title: "MyID는 어떻게 발급받을 수 있나요?",
      desc: `
     <p>'+'버튼이 있는 MyID는 발급받을 수 있는 MyID입니다. 발급받고 싶은 MyID를 선택해 생체인증 또는 비밀번호를 인증하면 MyID를 발급받아 사용하실 수 있습니다.</p>
    `,
      category: 2,
   },
   {
      title: "개명을 했는데 이전에 받은 MyID들의 이름 정보는 어떻게 바꾸나요?",
      desc: `
    <p>먼저, 개명된 이름으로 휴대폰 인증을 재발급 받아주세요. <br/>
    휴대폰 인증 이외의 MyID들도 상세 화면에서 재발급 받으면 개명된 이름으로 바뀐 MyID들을 받을 수 있습니다.</p>
    `,
      category: 2,
   },
   {
      title: "이전에 받은 MyID가 만료되었다고 나와요. 다시 쓸 순 없는 건가요?",
      desc: `
     <p>만료된 MyID를 클릭해 상세 화면에서 재발급을 받아주세요. 재발급 받은 MyID는 유효기간 내에서 얼마든지 사용할 수 있습니다.</p>
    `,
      category: 2,
      order: 1,
      isFrequent: true,
   },
   {
      title: "발급받은 MyID는 어떻게 사용할 수 있나요?",
      desc: `
    <p>MyID는 QR코드 스캔을 통해 유효성을 검증받아 사용할 수 있습니다. <br/>
     MyID를 클릭해 인증 상세 화면에 표시된 QR코드를 검증자에게 보여주세요.<br/>
     검증자가 쯩 앱 인증메뉴에서 QR코드를 스캔하면 인증이 완료됩니다.</p>
    `,
      category: 2,
   },
   {
      title: "블루투스 인증이 되지 않아요.",
      desc: `
    <p>블루투스 인증을 하기 위해서는 인증자와 검증자 휴대폰 모두 블루투스가 켜져 있어야 합니다. <br/>
    두 휴대폰 기기의 블루투스 기능이 모두 켜져 있는지 확인한 후 이용해 주세요.</p>
    `,
      category: 2,
   },
   {
      title: "블루투스 인증을 사용하려는데 QR코드가 나오지 않아요.",
      desc: `
    <p>앱 설정 내 블루투스 권한이 허용되지 않으면 QR코드가 나타나지 않습니다. 앱 설정에서 블루투스 권한을 허용해 주세요.</p>
    <p class="gray">
    1) 안드로이드: 디바이스 설정 > 애플리케이션 > 쯩 for 공공기관 > 블루투스 권한 허용 <br/>
    2) iOS: 디바이스 설정 > 쯩 for 공공기관 > 블루투스 권한 허용</p>
    `,
      category: 2,
   },
   {
      title: "운전 면허증 또는 여권이 촬영되지 않아요.",
      desc: `
    <p>정확한 운전면허증과 여권 촬영을 위해 검은 배경에 운전면허증과 여권을 올려두고 빛이 반사되지 않게 주의해서 촬영해 주세요.</p>
    `,
      category: 2,
   },
   {
      title: "여권 NFC 태그가 되지 않아요.",
      desc: `
    <p>여권 NFC 태그를 위해서는 휴대폰에 여권을 올려두고 인식이 끝날 때까지는 여권을 때면 안됩니다.<br/>
    만약 두꺼운 케이스나 기타 악세서리를 쓰고 있다면 정확한 인식을 위해 잠시 제거한 후 보유하신 단말기의 NFC 위치를 확인하고 여권 뒷면을 천천히 움직이며 태깅해주세요.
    </p>
    `,
      category: 2,
   },
   {
      title: "NFT를 가지고 싶어요. 어떻게 받아볼 수 있나요?",
      desc: `
    <p>공공기관의 행사, 이벤트에 참여해 NFT 발급 QR코드를 스캔해주세요. 공공기관의 다양한 NFT를 QR코드 스캔만으로 쯩에 담아 보관할 수 있습니다</p>
    `,
      category: 3,
      order: 1,
      isFrequent: true,
   },
   {
      title: "NFT 정보는 어떻게 확인하나요?",
      desc: `
    <p>발급받은 NFT는 NFT 상세 화면에서 확인할 수 있습니다. NFT 발급일, 토큰 규격, 네트워크 등의 정보를 확인해 보세요.</p>
    `,
      category: 3,
   },
   {
      title: "앱 잠금 번호 또는 앱 비밀번호가 생각이 안나요.",
      desc: `<p>쯩 앱 잠금 번호 또는 비밀번호를 잊으신 경우, 앱을 삭제한 후 재설치해 주세요. 휴대폰 본인인증 후 비밀번호를 재설정하면 다시 서비스를 이용하실 수 있습니다.`,
      category: 4,
      order: 1,
      isFrequent: true,
   },
   {
      title: "제 휴대폰에서는 생체 인증 기능이 보이지 않아요.",
      desc: `<p>생체 인증 기능은 생체 인증 기능을 탑재한 일부 단말기에서만 이용할 수 있습니다.</p>
     <p class="gray">
    1) 안드로이드: Android 6.0(M) 이상 지문 인식이 탑재된 단말부터 지원 가능 <br/>
    2) iOS: iOS 12 이상 Touch ID 또는 Face ID가 탑재된 단말부터 지원 가능</p>
    `,
      category: 4,
   },
   {
      title: "생체 인증 시도 횟수를 초과했어요.",
      desc: `<p>생체 인증은 각 디바이스별 시스템 정책을 따르고 있습니다. </p>
       <p class="gray">
    1) 안드로이드: 생체 인증 시도 횟수 초과 시, 30초 후 다시 생체 인증 사용 <br/>
    2) iOS: 생체 인증 시도 횟수 초과 시, 잠금 해제 후 생체 인증 사용</p>
    `,
      category: 4,
   },
   {
      title: "생체 인증이 등록되지 않아요.",
      desc: `<p>휴대폰 설정에서 생체 인증 사용이 설정되었는지 확인해 주세요.  </p>
       <p class="gray">
1) 안드로이드: 설정 - 생체인증 및 보안 <br/>
2) iOS: 설정 - Face ID(또는 Touch ID) 및 암호</p>
    `,
      category: 4,
   },
   // {
   //    title: "운전면허증 촬영 후 실패했다고 나와요.",
   //    desc: `<p>쯩 앱 설치 시 등록했던 휴대폰 인증 정보와 다른 타인 운전면허증을 등록할 수 없습니다.
   //  본인 운전면허증을 촬영해도 실패하는 경우는 아래로 예상됩니다. </p>
   //  <p class="gray">
   //  1) 운전면허증 촬영 후 인식 정보(이름, 운전면허번호, 생년월일, 일련번호 등)가 다른 경우, 재촬영 또는 인식 정보 수정 후 다시 시도해주세요. <br />
   //  2) 운전면허증 인식 정보를 올바르게 입력했음에도 실패한 경우 도로교통공단 고객센터(1577-1120)를 통해 확인 부탁드립니다.</p>`,
   //    category: 4,
   // },
   // {
   //    title: "운전면허증 정보 해킹 또는 도용 문제는 없나요?",
   //    desc: `<p>운전면허인증 정보는 휴대폰 내 안전한 영역에 저장되며 정보 제출이 필요할 때만 사용자 인증을 거쳐 이용됩니다.
   //  또한, 블록체인에 운전면허인증 발급/제출 이력이 기록되어 데이터 위변조를 방지합니다. 휴대폰 기기 변경 시에는 더 안전한 사용을 위해 이전 기기에서 앱을 삭제하시길 바랍니다.
   //  </p>`,
   //    category: 4,
   // },
   // {
   //    title: "운전면허인증 정보를 삭제할 수 있나요?",
   //    desc: `<p>발급된 운전면허인증은 운전면허인증 상세 화면 하단 '삭제' 선택 > 사용자 인증 후 삭제할 수 있습니다.
   //  삭제 시 휴대폰 내에 저장된 운전면허인증 정보도 삭제되며 추후 이용을 원할 시 재발급을 받아야 합니다.</p>`,
   //    category: 4,
   // },
   // // 기타
   // {
   //    title: "'코로나19 예방접종 정보'와 '제주안심코드'는 서비스 하지 않나요?",
   //    desc: `
   //  <p>질병청의 방역패스 정책 중단으로 인하여 코로나19 예방접종 정보 발급과 재발급은 중단되었습니다. 기 발급하신 접종 정보는 홈 화면의 ‘코로나19 예방접종 정보’ 배너를 선택하면 백신 접종 상세를 확인하실 수 있습니다. 단, 2차 접종까지 마지막으로 접종 정보를 업데이트 한 내용만 확인 가능합니다. 추가접종 정보는 확인할 수 없으니 이용에 참고 부탁드립니다. <br/>
   //  <br/>
   //  제주안심코드 또한 방역 정책의 변경으로 인해 더이상 운영하지 않아 신규 발급이나 재발급을 중단하였습니다. 기존에 제주안심코드를 발급한 사용자 분들께서는 필요시 홈 화면의 제주안심코드' 배너를 선택하면 상세를 확인하거나 삭제할 수 있습니다..
   //  </p>
   //  `,
   //    category: 5,
   //    order: 0,
   //    isFrequent: true,
   // },
   // {
   //    title: "이용내역이 무엇인가요?",
   //    desc: `
   //  <p>이용내역을 통해 인증정보가 제출된 곳과 일시, 제공된 개인정보 상세 내역을 볼 수 있습니다. 내 개인정보를 내가 안전하게 관리할 수 있도록 하는 기능입니다.</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "이용내역은 어디서 볼 수 있나요?",
   //    desc: `
   //  <p>이용내역은 쯩 앱의 홈 화면 우측 상단의 이용내역 버튼을 통해 확인할 수 있습니다. 현재로부터 8개월 전까지의 내역을 제공하며, 그 이전의 내역은 자동 삭제됩니다.</p>
   //  `,
   //    category: 5,
   //    order: 1,
   //    isFrequent: true,
   // },
   // {
   //    title: "어플리케이션을 다시 설치했을 때 이전 이용내역을 볼 수 있나요?",
   //    desc: `
   //  <p>어플리케이션을 다시 설치할 경우, 데이터가 초기화되기 때문에 이전 이용내역을 확인할 수 없습니다.</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "제 휴대폰에서는 생체 인증 기능이 보이지 않아요.",
   //    desc: `
   //  <p>생체 인증 기능은 생체 인증 기능을 탑재한 일부 단말기에서만 이용이 가능합니다.</p>
   //  <p class="gray">
   //  1) AOS : Android 6.0(M) 이상 지문인식이 탑재된 단말부터 지원 가능<br/>
   //  2) iOS : iOS 12 이상 Touch ID 또는 Face ID가 탑재된 단말부터 지원 가능</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "생체 인증 시도 횟수를 초과했다고 나와요.",
   //    desc: `
   //  <p>생체 인증은 각 디바이스별 시스템 정책을 따르고 있습니다. </p>
   //  <p class="gray">
   //  1) AOS : 생체 인증 시도 횟수 초과 시, 30초 후 다시 생체 인증 사용<br/>
   //  2) iOS : 생체 인증 시도 횟수 초과 시, 잠금해제 후 생체 인증 사용</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "생체 인증이 등록되지 않아요.",
   //    desc: `
   //  <p>휴대폰 설정에서 생체 인증 사용이 설정되었는지 확인해주세요.</p>
   //  <p class="gray">
   //  1) iOS : 설정 - Face ID(또는 Touch ID) 및 암호<br />
   //  2) 안드로이드 : 설정 - 생체 인증 및 보안</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "비밀번호를 변경하고 싶어요.",
   //    desc: `
   //  <p>비밀번호는 ‘설정>인증 관리>비밀번호 변경'에서 변경할 수 있습니다. 비밀번호는 분실하면 다시 찾을 수 없으니 신중하게 설정해주세요.</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "비밀번호가 생각이 안나요.",
   //    desc: `
   //  <p>쯩은 비밀번호를 포함한 사용자 정보를 따로 저장하지 않습니다. 따라서 비밀번호 분실 시 되찾을 수 없으며 서비스를 초기화하여 사용해야 합니다. 앱을 삭제 후 재설치하면 서비스 초기화가 완료됩니다.</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "신분증 촬영하는데 카메라가 실행되지 않아요.",
   //    desc: `
   //  <p>앱 설정 내 카메라 권한이 허용되지 않았을 때, 촬영이 진행되지 않습니다. </p>
   //  <p class="gray">
   //  1) AOS : 디바이스 설정 > 애플리케이션 > 쯩 > 카메라 권한 허용
   //  2) iOS :  디바이스 설정 > 쯩 > 카메라 권한 허용</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "서비스를 그만 사용하고 싶은데 내 개인정보가 남아있지 않나요?",
   //    desc: `
   //  <p>앱을 지우면 발급받은 모든 정보가 삭제됩니다. 또한, 사용 시 등록한 정보는 사용자 기기 이외에 따로 저장되지 않습니다.</p>
   //  `,
   //    category: 5,
   // },
   // {
   //    title: "앱을 실행했더니 갑자기 앱 초기화하라고 나와요.",
   //    desc: `
   //  <p>쯩 앱은 고객 정보를 암호화하여 앱 내에 저장하고 있어 기기 변경 후 데이터를 이전한 경우에는
   //  해당 데이터를 사용하지 못하도록 합니다.</p>

   //  <p>기기 변경의 경우 쯩 앱을 재설치하고 이용하도록 안내하고 있습니다.
   //  다소 불편하시더라도 사용자 정보 보호를 위해 앱초기화를 부탁드립니다.
   //  </p>
   //  `,
   //    category: 5,
   // },
];

export { faqData, categoryData };
